// src/components/common/DropdownMenu.js
import React from 'react';
import styled from 'styled-components';

const ListItem = styled.li`
  position: relative;
  list-style: none;
  
  /* 데스크탑: 호버시 드롭다운 표시 */
  @media (min-width: 769px) {
    &:hover > div { display: block; }
  }
`;

const MainLink = styled.a`
  color: #ffffff;
  font-size: 1.05rem;
  font-weight: 600;
  padding: 1.2rem 1.5rem;
  display: block;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  z-index: 11;

  &:hover { color: #60a5fa; }

  /* 모바일에서는 상단 메뉴만 굵게 */
  @media (max-width: 768px) {
    padding: .9rem 0;
  }
`;

const DropdownContainer = styled.div`
  display: none;
  position: absolute;
  left: 50%;
  top: -1.6rem;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(15px);
  min-width: 220px;
  width: max-content;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  z-index: 10;
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;

  @media (max-width: 768px) {
    display: none !important; /* 모바일에선 아코디언으로 대체 */
  }
`;

const MenuItemArea = styled.div`
  height: calc(4.8rem + 1.7rem);
  display: flex; align-items: center; justify-content: center;
  color: #ffffff;
  font-size: 1.05rem; font-weight: 600;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

/* 데스크탑 드롭다운 내부 */
const SubMenu = styled.ul`
  list-style: none;
  padding: 0.5rem 0;
  margin: 0;
`;

const SubMenuItem = styled.li`
  a {
    display: block;
    color: #e5e7eb;
    font-size: 0.98rem;
    padding: 0.9rem 1.5rem;
    transition: all 0.3s ease;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
      background: rgba(96, 165, 250, 0.2);
      color: #ffffff;
    }
  }
`;

/* --------- 모바일 전용(아코디언) --------- */
const MobileSubWrap = styled.div`
  @media (min-width: 769px) { display: none; }
  padding: 0 .25rem .4rem .25rem;
`;

const MobileSub = styled.ul`
  list-style: none;
  margin: .25rem 0 0 0;
  padding: .4rem .5rem .2rem .75rem;
  border-left: 2px solid rgba(255,255,255,.15);
  display: grid;
  gap: .35rem;
`;

const MobileSubLink = styled.a`
  display: block;
  color: #e5e7eb;
  padding: .55rem .6rem;
  border-radius: 8px;
  text-decoration: none;
  transition: background .2s, color .2s;

  &:hover { background: rgba(255,255,255,.08); color: #fff; }
`;

export default function DropdownMenu({ item, isMobile, onNavigate }) {
  if (isMobile) {
    // ✅ 모바일: 아코디언형 인라인 서브메뉴(디자인 유지, 구조만 변경)
    return (
      <ListItem>
        <MainLink href={item.path} onClick={onNavigate}>
          {item.title}
        </MainLink>
        <MobileSubWrap>
          <MobileSub>
            {item.sub.map((sub, idx) => (
              <li key={sub}>
                <MobileSubLink
                  href={item.subPaths[idx]}
                  onClick={onNavigate}
                >
                  {sub}
                </MobileSubLink>
              </li>
            ))}
          </MobileSub>
        </MobileSubWrap>
      </ListItem>
    );
  }

  // 🖥 데스크탑: 기존 호버 드롭다운 그대로
  return (
    <ListItem>
      <MainLink href={item.path}>{item.title}</MainLink>
      <DropdownContainer>
        <MenuItemArea />
        <SubMenu>
          {item.sub.map((sub, idx) => (
            <SubMenuItem key={sub}>
              <a href={item.subPaths[idx]}>{sub}</a>
            </SubMenuItem>
          ))}
        </SubMenu>
      </DropdownContainer>
    </ListItem>
  );
}
